/**
 * Read More JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class ReadMore
 */
export default class ReadMore {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

        // Bind this.
        ReadMore.updateReadMoresforAjax = ReadMore.updateReadMoresforAjax.bind( this );
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        this.readMoreBtn = $( '.read-more-button' );
        this.transparentContent = $( '.transparent-content' );
        this.readMoreContent = $( '.read-more' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        $( this.readMoreBtn ).on( 'click', ( e ) => {
            this.showAllContent( e );
        });
    }

    /**
     * This method initializes dynamic accessibility for the read more content.
     * If somehow JS isn't able to load, the content is still visible.
     */
    a11y() {
        this.transparentContent.removeClass( 'js-hidden' );
        this.readMoreBtn.removeClass( 'js-hidden' );
        this.readMoreContent.addClass( 'js-hidden' );
    }

    /**
     * This handles the visibility and aria classes of the read more button and the read more content.
     *
     */
    showAllContent( e ) {

        const button = e.target.parentElement;

        const container = e.target.parentElement.parentElement;
        const readMoreText = container.querySelector( '.read-more__text' );
        const readLessText = container.querySelector( '.read-less__text' );
        const overlay = container.querySelector( '.transparent-content' );
        const content = container.querySelector( '.read-more' );

        if ( $( button ).hasClass( 'text-hidden' ) ) {

            // Show hidden text.
            $( content ).removeClass( 'js-hidden' );

            // Change button's class.
            $( button ).addClass( 'text-visible' );
            $( button ).removeClass( 'text-hidden' );

            // Hide the overlay.
            $( overlay ).addClass( 'js-hidden' );

            // Change the aria states.
            $( button ).attr( 'aria-expanded', 'true' );

        } else if ( $( button ).hasClass( 'text-visible' ) ) {

            // Change button's class.
            $( button ).removeClass( 'text-visible' );
            $( button ).addClass( 'text-hidden' );

            // Hide text.
            $( content ).addClass( 'js-hidden' );

            // Show the overlay.
            $( overlay ).removeClass( 'js-hidden' );

            // Change the aria states.
            $( button ).attr( 'aria-expanded', 'false' );
        }
    }

    /**
     * Make read mores work after AJAX requests, e.g. in models search page.
     *
     * @return {void}
     */
    static updateReadMoresforAjax() {
        this.docReady();
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.a11y();
        this.events();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/read-more.js